import { z } from 'zod'

/**
 * The chapters of a shared proposal, in reading order.
 *
 * These ids are the anchors on the client page (`data-chapter`) and the
 * detail of a READ activity event. The labels are what the chapter list and
 * the salesperson's activity panel both show.
 *
 * `ProposalChapter` and `PROPOSAL_CHAPTER_LABELS` fail the build when an id
 * is unknown or a label is missing. The document nav is written out by hand,
 * so a chapter that nothing renders still compiles.
 */
export const PROPOSAL_CHAPTERS = [
  'short',
  'property',
  'found',
  'why',
  'plan',
  'later',
  'how',
  'next',
  'appendix',
] as const

export const proposalChapterSchema = z.enum(PROPOSAL_CHAPTERS)

export type ProposalChapter = z.infer<typeof proposalChapterSchema>

/** What a salesperson reads, and what the chapter list links to. */
export const PROPOSAL_CHAPTER_LABELS: Record<ProposalChapter, string> = {
  short: 'The short version',
  property: 'Your property',
  found: 'What we found',
  why: 'Why us',
  plan: 'Your plan',
  later: 'Future work',
  how: 'How the work goes',
  next: 'Next steps',
  appendix: 'Appendix',
}
